import DefectData from "./defectData";
import { FilterItem } from "../api/Types";
import { FilterCondition } from "../constants/Enums";
import { ExpandableKeys } from "./core";
import { makeObservable, observable } from "mobx";

class PlannedDefectData extends DefectData {
  filterItems: FilterItem[] = [
    {
      fieldName: "isValid",
      value: false,
      condition: FilterCondition.Equal,
    },
    {
      fieldName: "eventTypeId",
      value: 3,
      condition: FilterCondition.Equal,
    },
    {
      fieldName: "incidentStatusId",
      value: 0,
      valueTo: 8,
      condition: FilterCondition.Between,
    },
  ];
  selectedRows = new ExpandableKeys();
  constructor() {
    super();
    this.dataLable = "Реестр плановых";
    makeObservable(
      this,
      {
        selectedRows: observable,
      }
    )
  }
}

const plannedDefectDataStore = new PlannedDefectData();
export default plannedDefectDataStore;